// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"096c640d","453":"7fbbb176"}[chunkId] + ".chunk.js";
};